export const API_V4 = 'apiV4';
export const LOGGER = 'logger';
export const VIEWPORT = {
    MOBILE: 'mobile',
    DESKTOP: 'desktop',
};
